module.exports = __webpack_public_path__ + "static/media/dlaughlogo.59f88887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dlaughlogo.jpg
// module id = 475
// module chunks = 0